// src/pages/super-admin/reports/ReportDetails.tsx

import { Button } from "@/components/ui/button";

export default function ReportDetails({ report, onClose }: any) {
  return (
    <div className="space-y-4 p-4">
      <p>
        <strong>Client:</strong> {report.client}
      </p>
      <p>
        <strong>User:</strong> {report.user}
      </p>
      <p>
        <strong>Test:</strong> {report.test}
      </p>
      <p>
        <strong>Date:</strong> {report.date}
      </p>
      <p>
        <strong>Status:</strong> {report.status}
      </p>

      {/* PDF Preview Placeholder */}
      <div className="border p-4 text-center bg-gray-50">
        PDF Preview Will Show Here
      </div>

      <div className="flex justify-end gap-3">
        <Button variant="outline" onClick={onClose}>
          Close
        </Button>
        <Button>Download Report</Button>
      </div>
    </div>
  );
}
